module.exports = __webpack_public_path__ + "img/ff-logo-header.c5f586c.svg";